import React, { useRef } from "react";
import "./ActualFeatures.scss";
import FeaturesCards from "./Cards";
import { useGSAP } from "@gsap/react";
import {
  splitTextIntoSpans,
  animateTextReveal,
  maskAnimation,
  animateCardPopup,
} from "../../../utils/gsapAnimations";

export default function ActualFeatures() {
  const largeTitleRef = useRef(null);
  const smallTitleRef = useRef(null);
  const cardsRef = useRef([]);

  // Split text using utility function
  const smallTitleSpans = splitTextIntoSpans("FEATURES", "");
  const largeTitleSpans = splitTextIntoSpans(
    "Here's what makes RentlyBuzz stand out"
  );

  useGSAP(() => {
    const isMobile = window.innerWidth <= 768;

    // Animate small title using utility
    animateTextReveal(smallTitleRef.current, {
      trigger: largeTitleRef.current,
      duration: 1.5,
      stagger: 0.09,
      isMobile,
    });

    // Use maskAnimation for the large title (changed from animateTextReveal)
    maskAnimation(largeTitleRef.current, {
      trigger: largeTitleRef.current,
      duration: 0.75,
      stagger: 0.03,
      start: "top 97%",
    });

    // // Animate large title using utility
    // animateTextReveal(largeTitleRef.current, {
    //   trigger: largeTitleRef.current,
    //   duration: 0.75,
    //   stagger: 0.03,
    //   isMobile,
    // });

    // Animate cards using utility
    animateCardPopup(cardsRef.current);
  }, []);

  return (
    <div className="actual-features" id="features">
      <div className="small-title" ref={smallTitleRef}>
        {smallTitleSpans}
      </div>
      <div className="large-title" ref={largeTitleRef}>
        {/* {largeTitleSpans} */}
        <span>Here's what makes RentlyBuzz stand out</span>
      </div>
      <FeaturesCards cardsRef={cardsRef} />
    </div>
  );
}
